import {
    OUTSOURCE_ASSIGNMENT_DISPLAY,
    OUTSOURCE_ASSIGNMENT_LOADING,
    OUTSOURCE_LOADING,
    OUTSOURCE_REMOVE,
    OUTSOURCE_UPDATE, OUTSOURCE_WORKS_CLEAN,
    OUTSOURCE_WORKS_LOADING,
    OUTSOURCE_WORKS_UPDATE,
    OUTSOURCES_ERROR,
    OUTSOURCES_LOADING,
    OUTSOURCES_UPDATE,
} from '../actions/outsourceActions';

const INITIAL_STATE = {
    outsources: [],
    outsourcesPagination: null,
    outsourcesLoading: false,
    outsourcesError: null,
    outsourceLoading: false,
    outsourceWorks: [],
    outsourceWorksLoading: false,
    outsourceAssignmentDisplay: false,
    outsourceAssignmentNIF: '',
    outsourceAssignmentLoading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case OUTSOURCE_ASSIGNMENT_DISPLAY:
            return {
                ...state,
                outsourceAssignmentDisplay: action.payload.displayDialog,
                outsourceAssignmentNIF: action.payload.nif
                    ? action.payload.nif
                    : state.outsourceAssignmentNIF,
            };

        case OUTSOURCE_ASSIGNMENT_LOADING:
            return {
                ...state,
                outsourceAssignmentLoading: action.payload,
            };

        case OUTSOURCES_UPDATE:
            return {
                ...state,
                outsources: action.payload.data,
                outsourcesPagination: action.payload.pagination,
                outsourcesError: action.payload.message,
            };

        case OUTSOURCE_UPDATE:
            const outsource = action.payload.data;
            const outsources = {...state.outsources, [outsource.id]: outsource};
            return {...state, outsources: outsources};

        case OUTSOURCE_REMOVE:
            const outsourcesToRemove = {...state.outsources};
            delete outsourcesToRemove[action.payload];
            return {...state, outsources: outsourcesToRemove};

        case OUTSOURCES_ERROR:
            return {
                ...state,
                outsourcesError: action.payload,
            };

        case OUTSOURCES_LOADING:
            return {...state, outsourcesLoading: action.payload};

        case OUTSOURCE_LOADING:
            return {...state, outsourceLoading: action.payload};

        case OUTSOURCE_WORKS_UPDATE:
            return {...state, outsourceWorks: action.payload};

        case OUTSOURCE_WORKS_LOADING:
            return {...state, outsourceWorksLoading: action.payload};

        case OUTSOURCE_WORKS_CLEAN:
            return {...state, outsourceWorks: []};

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/outsource/reducers/OutsourcesReducer.js